// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"statistics_statsContainer__MaJEG"};